import { render, staticRenderFns } from "./RelationPageUrl.vue?vue&type=template&id=005ab788&scoped=true&"
import script from "./RelationPageUrl.vue?vue&type=script&lang=js&"
export * from "./RelationPageUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ab788",
  null
  
)

export default component.exports